import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            category: z.object({
                documentId: z.string(),
                slug: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetSweetShopArticleCategoryTagsByCategoryUidActionResponse
    = ApiResponse<z.infer<typeof GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema>>
    | BaseError;

type GetSweetShopArticleCategoryTagsByCategoryUidActionRequest = {
    categoryUid: string
}

export const getSweetShopArticleCategoryTagsByCategoryUid = createAsyncThunk<
    GetSweetShopArticleCategoryTagsByCategoryUidActionResponse,
    GetSweetShopArticleCategoryTagsByCategoryUidActionRequest
>(
    'SweetShopArticlesPageActionsGetSweetShopArticleCategoryTagsByCategoryUid',
    async ({
        categoryUid,
    }) => apiInstance.get(
        '/sweet-shop-article-category-tags',
        {
            'filters[category][slug][$eq]': categoryUid,
            'fields[0]': 'name',
            'populate[category][fields]': '*',
        },
        GetSweetShopArticleCategoryTagsByCategoryUidApiResponseSchema,
    ),
);
